export const typeCondition = {
  TYPE_WALK_EASY: 'Forte endurance',
  TYPE_WALK_NORMAL: 'Endurance normale',
  TYPE_WALK_DIFF: 'Marche difficilement',
  TYPE_VISUAL_PART: 'Partielle (malvoyant)',
  TYPE_VISUAL_TOT: 'Totale (non-voyant)',
  TYPE_WHEEL_MAN: 'Fauteuil roulant manuel',
  TYPE_WHEEL_ELE: 'Fauteuil roulant électrique',
  TYPE_HEAR_PART: 'Partielle (malentendant)',
  TYPE_HEAR_TOT: 'Totale (sourd)',
  TYPE_MEN_INT: 'Trouble intellectuel',
  TYPE_MEN_PSY: 'Trouble psychique',

};
